/* IBM Confidential‌ - OCO Source Materials‌ - (C) COPYRIGHT IBM CORP. 2024 - The source code for this program is not published or otherwise‌ divested of its trade secrets, irrespective of what has been‌ deposited with the U.S. Copyright Office. */
// TAG: wxO: POC for Watson Orchestrate

import { NavConfig } from "./utils";

const state = { loaded: false };
const wxo = async () => {
  if (!state.loaded) {
    state.loaded = true;

    const getLoginUser = async () => {
      try {
        const userPath = "../../p/webapi/current-user";
        const resp = await fetch(userPath);
        const user = await resp.json();
        return user;
      } catch (ex) {
        console.log("Fetch user failed", ex);
        return "none";
      }
    };

    try {
      const {
        watsonOrchestrateEnabled: wxoEnabled,
        watsonOrchestrateInstanceId: serviceId,
        watsonOrchestrateIntegrationId: integrationId,
        watsonOrchestrateRegionId: regionId,
        userProfile: { userName },
      } = NavConfig.getNavConfigData();

      if (wxoEnabled === "TRUE") {
        const user = await getLoginUser();
        window.watsonAssistantChatOptions = {
          integrationID: integrationId, // The ID of this integration.
          region: regionId, // The region your integration is hosted in.
          serviceInstanceID: serviceId, // The ID of your service instance.

          onLoad: async (instance) => {
            if (!instance) {
              console.log( "WXO instance could not be created");
              return;
            }

            instance.on({
              type: "pre:send",
              handler: (event) => {
                if (event.data) {
                  if (!event.data.context.skills["actions skill"].skill_variables)
                    return;
                  try {
                    event.data.context.skills[
                      "actions skill"
                    ].skill_variables.userId = user.userId.toString();
                    event.data.context.skills[
                      "actions skill"
                    ].skill_variables.userName = userName;
                  } catch (ex) {
                    console.log("error");
                  }
                }
              },
            });
            
            await instance.render();

            document.addEventListener('tri-notify-wxo-session-expired', () => {
              instance.destroySession();
              instance.destroy();
            })
          },
        };

        setTimeout(function () {
          const t = document.createElement("script");
          t.src =
            "https://web-chat.global.assistant.watson.appdomain.cloud/versions/" +
            (window.watsonAssistantChatOptions.clientVersion || "latest") +
            "/WatsonAssistantChatEntry.js";
          document.head.appendChild(t);
        });
      } else {
        return;
      }
    } catch (ex) {
      console.log( "Watson Orchestrate not installed", ex);
    }
  }
};

const wxoLoader = () => {
  setTimeout(() => {
    wxo();
  }, 1000);
};

export default wxoLoader;
